import { render, staticRenderFns } from "./ShareACopy.vue?vue&type=template&id=6c3a1be0&scoped=true&"
import script from "./ShareACopy.vue?vue&type=script&lang=js&"
export * from "./ShareACopy.vue?vue&type=script&lang=js&"
import style0 from "./ShareACopy.vue?vue&type=style&index=0&id=6c3a1be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3a1be0",
  null
  
)

export default component.exports